















import { Component, Vue } from "vue-property-decorator";
import NavBar from "./components/NavBar.vue";
import ToastArea from "./components/ToastArea.vue";
import { Action } from "vuex-class";

@Component({
  components: {
    NavBar,
    ToastArea
  }
})
export default class App extends Vue {
  @Action("queue/load") loadQueue!: () => Promise<void>;

  created() {
    this.loadQueue();
  }
}
